// Response sets & field types (Fase 2). Scoring is frontend-driven; each scored
// option maps to a weight factor. factor null => N/A (excluded from score).
export const RESPONSE_SETS = {
  canales: {
    scored: true,
    options: [
      { v: "yes", factor: 1, tone: "good" },
      { v: "no", factor: 0, tone: "poor" },
      { v: "en_proceso", factor: 0.5, tone: "fair" },
      { v: "warning", factor: 0.25, tone: "warn" },
      { v: "multa", factor: -1, tone: "multa" },
    ],
    flagged: ["no", "en_proceso", "warning", "multa"],
  },
  good_fair_poor: {
    scored: true,
    options: [
      { v: "good", factor: 1, tone: "good" },
      { v: "fair", factor: 0.5, tone: "fair" },
      { v: "poor", factor: 0, tone: "poor" },
      { v: "na", factor: null, tone: "na" },
    ],
    flagged: ["fair", "poor"],
  },
  pass_fail: {
    scored: true,
    options: [
      { v: "pass", factor: 1, tone: "good" },
      { v: "fail", factor: 0, tone: "poor" },
      { v: "na", factor: null, tone: "na" },
    ],
    flagged: ["fail"],
  },
  compliant: {
    scored: true,
    options: [
      { v: "compliant", factor: 1, tone: "good" },
      { v: "non_compliant", factor: 0, tone: "poor" },
      { v: "na", factor: null, tone: "na" },
    ],
    flagged: ["non_compliant"],
  },
  safe_risk: {
    scored: true,
    options: [
      { v: "safe", factor: 1, tone: "good" },
      { v: "at_risk", factor: 0, tone: "poor" },
      { v: "na", factor: null, tone: "na" },
    ],
    flagged: ["at_risk"],
  },
  text: { scored: false, field: "text" },
  number: { scored: false, field: "number" },
  media: { scored: false, field: "media" },
  signature: { scored: false, field: "signature" },
};

export const RESPONSE_TYPE_OPTIONS = Object.keys(RESPONSE_SETS);

export function setFor(rt) {
  return RESPONSE_SETS[rt] || RESPONSE_SETS.canales;
}

export function isDataCapture(rt) {
  return !setFor(rt).scored;
}

export function flaggedDefaultFor(rt) {
  return setFor(rt).flagged || [];
}

// Aggregate scoring maps used by score.js. Values are unique across sets.
export const RESPONSE_WEIGHT = { cumple: 1, no_cumple: 0 };
export const COUNTING_RESPONSES = new Set(["cumple", "no_cumple"]);
Object.values(RESPONSE_SETS).forEach((s) => {
  if (!s.scored) return;
  s.options.forEach((o) => {
    if (o.factor == null) return;
    RESPONSE_WEIGHT[o.v] = o.factor;
    COUNTING_RESPONSES.add(o.v);
  });
});

// Active-state classes for alternate-set pill buttons.
export const TONE_CLASSES = {
  good: "bg-emerald-600 text-white border-emerald-600",
  fair: "bg-amber-500 text-white border-amber-500",
  warn: "bg-orange-500 text-white border-orange-500",
  poor: "bg-red-600 text-white border-red-600",
  multa: "bg-red-700 text-white border-red-700",
  na: "bg-stone-400 text-white border-stone-400",
};
